import { DataSource } from '@n7-frontend/core';
import { IChartData } from '@n7-frontend/components';
import { Utils } from './utils';
export class RevenuesDS extends DataSource {
  protected transform(data): IChartData {
    if (!data || !data.companies || !data.companies.length) {
      return;
    }

    const economical_data = data.companies[0].economical_data;
    const values = [];
    const categs = [];
    Utils.sortByYear(economical_data.revenues.values).forEach(x => {
      values.push(x.value);
      categs.push(x.year);
    });
    if (!values || values.length === 0) {
      return {
        containerId: null,
        libOptions: null,
        payload: { loaded: true }
      };
    }

    const chartOption = {
      series: [{
        name: 'Ricavi',
        data: values
      }],
      colors: ['#00963F'],
      chart: {
        id: 'revenues-chart',
        fontFamily: 'Open Sans',
        height: 100,
        animations: {
          enabled: data.noAnimation ? false : true
        },
        type: 'line',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false,
        }
      },
      stroke: {
        width: 2,
        curve: 'straight',
      },
      markers: {
        size: [3],
        strokeWidth: 0,
        hover: {
          size: [5]
        }
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        offsetY: -20,
        style: {
          fontSize: '11px',
          fontFamily: 'Open Sans',
          fontWeight: 'noemal',
          colors: undefined
        },
        background: {
          enabled: false,
        },
      },
      xaxis: {
        categories: categs,
        labels: {
          show: false
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: false
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        min: (min) => min - (Math.abs(min) / Utils.minMaxAxis),
        max: (max) => max + (Math.abs(max) / Utils.minMaxAxis),
        tickAmount: 5,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      grid: {
        yaxis: {
          lines: {
            show: false
          }
        },
        xaxis: {
          lines: {
            show: false
          }
        }
      },
      tooltip: {
        y: {
          formatter: (value) => {
            return Utils.bigNumberConverter(Math.round(value));
          }
        }
      },
      noData: {
        text: 'Dato non disponibile',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#474747',
          fontSize: '14px',
          fontFamily: 'Open Sans'
        }
      }
    };

    return {
      containerId: 'revenues-chart',
      libOptions: chartOption,
      payload: { loaded: true }
    };

  }
}
